/* WOOMN - infinite scroll for collection pages.
   Replaces numbered pagination: loads the next page and appends the products
   to #product-grid as the shopper nears the bottom. Falls back to a plain
   "Load more" link if JS or IntersectionObserver is unavailable. */
(function () {
  var SENTINEL = '[data-infinite-next]';
  var GRID = '#product-grid';
  var loading = false;
  var io = null;
  var sentinel = null;

  // Appended cards must not keep the scroll-reveal classes, or they stay invisible
  // because the theme's animation observer never picks them up.
  function clean(node) {
    if (!node || node.nodeType !== 1) return;
    var list = [node].concat(Array.prototype.slice.call(node.querySelectorAll('.scroll-trigger')));
    list.forEach(function (n) {
      n.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--slide-in', 'animate--fade-in');
      n.removeAttribute('data-cascade');
      if (n.style) n.style.removeProperty('--animation-order');
    });
  }

  function stop() {
    if (io) {
      io.disconnect();
      io = null;
    }
  }

  function load() {
    if (loading || !sentinel) return;
    var url = sentinel.getAttribute('data-infinite-next');
    if (!url) return;

    loading = true;
    sentinel.classList.add('is-loading');

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var incoming = doc.querySelector(GRID);
        var grid = document.querySelector(GRID);
        if (!incoming || !grid) throw new Error('product grid not found');

        var frag = document.createDocumentFragment();
        var added = 0;
        Array.prototype.slice.call(incoming.children).forEach(function (child) {
          clean(child);
          frag.appendChild(child);
          added++;
        });
        grid.appendChild(frag);

        var status = sentinel.querySelector('[data-infinite-status]');
        if (status) status.textContent = added + ' more products loaded';

        var nextEl = doc.querySelector(SENTINEL);
        var nextUrl = nextEl ? nextEl.getAttribute('data-infinite-next') : null;

        if (nextUrl) {
          sentinel.setAttribute('data-infinite-next', nextUrl);
          var a = sentinel.querySelector('a');
          if (a) a.setAttribute('href', nextUrl);
        } else {
          // No further pages - retire the sentinel entirely.
          stop();
          if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
          sentinel = null;
        }

        document.dispatchEvent(new CustomEvent('infinite-scroll:appended', { detail: { count: added } }));
      })
      .catch(function (err) {
        console.error('[infinite-scroll]', err);
        stop();
        // Surface the manual link again so the shopper is never stuck.
        if (sentinel) sentinel.removeAttribute('data-js');
      })
      .then(function () {
        loading = false;
        if (sentinel) sentinel.classList.remove('is-loading');
      });
  }

  function init() {
    var found = document.querySelector(SENTINEL);
    if (found === sentinel && io) return;

    stop();
    sentinel = found;
    if (!sentinel) return;

    var a = sentinel.querySelector('a');
    if (a && !a.getAttribute('data-infinite-bound')) {
      a.setAttribute('data-infinite-bound', '1');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        load();
      });
    }

    if (!('IntersectionObserver' in window) || typeof fetch !== 'function') return;

    sentinel.setAttribute('data-js', '');
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) load();
        });
      },
      { rootMargin: '800px 0px' }
    );
    io.observe(sentinel);
  }

  function boot() {
    init();
    // Filtering and sorting swap out the grid markup, so watch for a new sentinel.
    var host = document.querySelector('collection-section') || document.body;
    new MutationObserver(function () {
      if (document.querySelector(SENTINEL) !== sentinel) init();
    }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
